// @ts-nocheck
import moment from 'moment'
import React, { Component } from 'react'
import Datetime from 'react-datetime'
import { withTranslation } from 'react-i18next'
import { Button, FormGroup, Input, Label, Table, Modal, ModalBody } from 'reactstrap'
import { identityServices, Loader } from '../../common'
import AsyncJobsModal from '../../common/ticketing/components/AsyncJobsModel'
import '../style.css'
import Select from 'react-select'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, } from 'recharts'
import { AlternateEmail } from '@material-ui/icons'
import { Tooltip } from '@chakra-ui/react'

const ChartComponent = props => {
	const data = props.chartData
	if (props.display) {
		return (
			<>
				<BarChart width={700} height={250} data={data}>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="name" />
					<YAxis domain={[0, 1000]} />
					<Tooltip />

					<Bar dataKey="total" fill="#8884d8" />
					{/* <Bar dataKey="uv" fill="#82ca9d" /> */}
				</BarChart>
			</>
		)
	}
}
let statusOptions = []
let queueOptions = []
let countVal

class FilterReview extends Component {
	modalPopup(displayModal, chartData, queueList) {
		const today = this.state.popupEndDate
		// const fromDefault= moment().startOf('month')
		const disableFutureDt = current => {
			return current.isBefore(today) && current.isAfter(this.state.popupStartDate)
		}

		return (
			<div>
				<Modal style={{ maxWidth: '850px' }} autoFocus={false} isOpen={displayModal} backdrop="static">
					<ModalBody>
						<>
							<div style={{ textAlign: 'justify', padding: '20px 0px 20px 0px' }}>
								<h6>
									Below is a data visualization for the requested Interval. Unfortunately, This data set exceeds 1000 rows we couldn't generate an excel report. Would request you
									choose a revised interval so the data set is less than 1000 rows.
								</h6>
							</div>
							<div style={{ textAlign: 'justify', padding: '20px 0px 20px 0px' }}>
								<h6>Total open tickets : {`${countVal}`}</h6>
							</div>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<div style={{ display: 'flex' }}>
									<div style={{ display: 'flex', alignItems: 'center' }}>
										<label>
											<span style={{ fontWeight: 'bold' }}>Status: </span>
										</label>
										{/* <select name='Status' value={this.state.statusFilterValue} onChange={this.handleChange.bind(this)}>
									{this.state.statusList}
								</select> */}
										<div style={{ width: '160px' }}>
											<Select
												menuPlacement="top"
												name="Status"
												options={statusOptions}
												placeholder="Select status"
												value={this.state.statusValue}
												onChange={this.handleStatusChanges.bind(this)}
												isMulti
											/>
										</div>
									</div>
									<div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
										<label>
											<span style={{ fontWeight: 'bold' }}>Queue: </span>
										</label>
										{/* <select name='Queue' value={this.state.queueFilterValue} onChange={this.handleChange.bind(this)}>
								{queueList}
							</select> */}
										<div style={{ width: '160px' }}>
											<Select
												menuPlacement="top"
												name="Queue"
												options={queueOptions}
												placeholder="Select queue"
												value={this.state.queueValue}
												onChange={this.handleQueueChanges.bind(this)}
												isMulti
											/>
										</div>
									</div>
								</div>
								<div style={{ display: 'inline-flex' }}>
									<span style={{ fontWeight: 'bold', paddingLeft: '10px' }}>From Date: </span>
									<input
										style={{ width: 'auto', maxWidth: '100%', borderBottom: 'none' }}
										name="startDate"
										type="date"
										value={this.state.popupStartDate}
										onChange={this.dateChange.bind(this)}
										max={moment().format('YYYY-MM-DD')}
										format="DD-MM-YYYY"
									/>
									<span style={{ fontWeight: 'bold', paddingLeft: '10px' }}>To Date: </span>
									<input
										style={{ width: 'auto', maxWidth: '100%', borderBottom: 'none' }}
										name="endDate"
										type="date"
										value={this.state.popupEndDate}
										onChange={this.dateChange.bind(this)}
										max={this.state.maxDate}
										min={this.state.popupStartDate}
									/>
								</div>
								<div></div>
							</div>
						</>
						<div style={{ marginTop: '22px', marginLeft: '40px' }}>
							<ChartComponent display={true} chartData={chartData} />
						</div>
					</ModalBody>
					<div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '40px' }}>
						<Button name="close" color="secondary" onClick={this.onCLickSubmit.bind(this)}>
							Close
						</Button>
						<Button name="submit" color="secondary" onClick={this.onCLickSubmit.bind(this)}>
							Submit
						</Button>
					</div>
				</Modal>
			</div>
		)
	}

	dateChange(e) {
		if (e.target.name == 'startDate') {
			this.setState({ popupStartDate: e.target.value })
			let today = moment().format('YYYY-MM-DD')
			let date = new Date(`${e.target.value}`).getTime()
			let oneYear = 31556952000
			let newDate = date + oneYear
			let d = new Date(newDate)
			if (new Date(newDate).getTime() <= new Date(today).getTime()) {
				this.setState({ maxDate: moment(d.toLocaleDateString()).format('YYYY-MM-DD') })
				this.setState({ popupEndDate: moment(d.toLocaleDateString()).format('YYYY-MM-DD') })
			} else {
				this.setState({ maxDate: moment().format('YYYY-MM-DD') })
			}
		} else if (e.target.name == 'endDate') {
			this.setState({ popupEndDate: e.target.value })
		}
	}

	onCLickSubmit(e) {
		if (e.target.name == 'close') {
			this.setState({ displayModal: false })
			this.setState({ isChartVisible: false })
			window.location.reload()
		} else if (e.target.name == 'submit') {
			this.setState({ displayModal: false })
			this.setState({ isChartVisible: false })
			this.getTicketReport('downloadIndividual', 'openTicketSummaryReport')
		}
	}

	setStartDateValue() {
		let today = moment().format('YYYY-MM-DD')
		let date = new Date(`${today}`).getTime()
		let oneYear = 31556952000
		let newDate = date - oneYear
		let d = new Date(newDate)
		this.setState({ popupStartDate: moment(d.toLocaleDateString()).format('YYYY-MM-DD') })
	}

	constructor(props) {
		super(props)
		let startDate = moment().startOf('month')
		let endDate = new Date()
		this.state = {
			popupStartDate: moment().startOf('month').format('YYYY-MM-DD'),
			popupEndDate: moment().format('YYYY-MM-DD'),
			maxDate: moment().format('YYYY-MM-DD'),
			chartData: '',
			allData: ' ',
			statusValue: null,
			queueValue: null,
			queueList: ' ',
			statusList: ' ',
			statusFilterValue: ' ',
			queueFilterValue: ' ',
			isChartVisible: false,
			displayModal: false,
			allowed: [],
			selected: [],
			loading: false,
			reportData: {},
			selectAll: false,
			selectFrom: false,
			selectTo: false,
			popUp: false,
			filters: {
				startDate,
				endDate,
			},
			reportsArr: [
				{
					label: props.t('Ticket Detail Report'),
					action: this.getTicketReport.bind(this),
					name: 'ticketReport',
					startDate,
					endDate,
					description: props.t('All Created Tickets'),
					notes: 'ticketReport',
					condition: [{ name: 'allNotes', label: 'Include All Notes', type: 'checkbox' }],
					From: {
						value: moment().startOf('year').format('YYYY-MMM-DD'),
						open: false,
						onClick: this.toggleCalArr.bind(this, 'From', 'ticketReport'),
					},
					To: {
						value: '',
						open: false,
						onClick: this.toggleCalArr.bind(this, 'To', 'ticketReport'),
					},
				},
				{
					label: props.t('Request Approval Report'),
					action: this.getTicketReport.bind(this),
					name: 'approvalReport',
					startDate,
					endDate,
					description: props.t('All Request Approval Report'),
					notes: 'approvalReport',
					condition: [{ name: 'allNotes', label: 'Include All Notes', type: 'checkbox' }],
					From: {
						value: moment().startOf('year').format('YYYY-MMM-DD'),
						open: false,
						onClick: this.toggleCalArr.bind(this, 'From', 'approvalReport'),
					},
					To: {
						value: '',
						open: false,
						onClick: this.toggleCalArr.bind(this, 'To', 'approvalReport'),
					},
				},
				{
					label: props.t('SLA Report'),
					action: this.getTicketReport.bind(this),
					name: 'slaReport',
					startDate,
					endDate,
					description: props.t('All SLA Report'),
					notes: 'slaReport',
					condition: [{ name: 'allNotes', label: 'Include All Notes', type: 'checkbox' }],
					From: {
						value: moment().startOf('year').format('YYYY-MMM-DD'),
						open: false,
						onClick: this.toggleCalArr.bind(this, 'From', 'slaReport'),
					},
					To: {
						value: '',
						open: false,
						onClick: this.toggleCalArr.bind(this, 'To', 'slaReport'),
					},
				},
				{
					label: props.t('Feedback Report'),
					action: this.getTicketReport.bind(this),
					name: 'feedbackReport',
					startDate,
					endDate,
					description: props.t('Feedback Report'),
					From: {
						value: moment().startOf('year').format('YYYY-MMM-DD'),
						open: false,
						onClick: this.toggleCalArr.bind(this, 'From', 'feedbackReport'),
					},
					To: {
						value: '',
						open: false,
						onClick: this.toggleCalArr.bind(this, 'To', 'feedbackReport'),
					},
				},
				{
					label: props.t('Queue Summary Report'),
					action: this.getTicketReport.bind(this),
					name: 'queueSummaryReport',
					startDate,
					endDate,
					description: props.t('All Tickets by Queue'),
					From: {
						value: moment().startOf('year').format('YYYY-MMM-DD'),
						open: false,
						onClick: this.toggleCalArr.bind(this, 'From', 'queueSummaryReport'),
					},
					To: {
						value: '',
						open: false,
						onClick: this.toggleCalArr.bind(this, 'To', 'queueSummaryReport'),
					},
				},
				{
					label: props.t('Source Summary Report'),
					action: this.getTicketReport.bind(this),
					name: 'sourceSummaryReport',
					startDate,
					endDate,
					description: props.t('All Tickets by Source'),
					From: {
						value: moment().startOf('year').format('YYYY-MMM-DD'),
						open: false,
						onClick: this.toggleCalArr.bind(this, 'From', 'sourceSummaryReport'),
					},
					To: {
						value: '',
						open: false,
						onClick: this.toggleCalArr.bind(this, 'To', 'sourceSummaryReport'),
					},
				},
				{
					label: props.t('Agent Workload Report'),
					action: this.getTicketReport.bind(this),
					name: 'agentWorkloadReport',
					startDate,
					endDate,
					description: props.t('All Tickets by Queue and by Agent'),
					From: {
						value: moment().startOf('year').format('YYYY-MMM-DD'),
						open: false,
						onClick: this.toggleCalArr.bind(this, 'From', 'agentWorkloadReport'),
					},
					To: {
						value: '',
						open: false,
						onClick: this.toggleCalArr.bind(this, 'To', 'agentWorkloadReport'),
					},
				},
				{
					label: props.t('Total Ticket vs Bot Ticket Report'),
					action: this.getTicketReport.bind(this),
					name: 'botTicketReport',
					startDate,
					endDate,
					description: props.t('Total Ticket vs Bot Ticket Report'),
					From: {
						value: moment().startOf('year').format('YYYY-MMM-DD'),
						open: false,
						onClick: this.toggleCalArr.bind(this, 'From', 'botTicketReport'),
					},
					To: {
						value: '',
						open: false,
						onClick: this.toggleCalArr.bind(this, 'To', 'botTicketReport'),
					},
				},
				{
					label: props.t('Category Summary Report'),
					action: this.getTicketReport.bind(this),
					name: 'categoryWiseReport',
					startDate,
					endDate,
					description: props.t('All Tickets by Category'),
					From: {
						value: moment().startOf('year').format('YYYY-MMM-DD'),
						open: false,
						onClick: this.toggleCalArr.bind(this, 'From', 'categoryWiseReport'),
					},
					To: {
						value: '',
						open: false,
						onClick: this.toggleCalArr.bind(this, 'To', 'categoryWiseReport'),
					},
				},
				{
					label: props.t('Open Ticket Summary'),
					action: this.getTicketReport.bind(this),
					name: 'openTicketSummaryReport',
					startDate,
					endDate,
					description: props.t('Open Ticket Summary'),
					From: {
						value: moment().startOf('year').format('YYYY-MMM-DD'),
						open: false,
						onClick: this.toggleCalArr.bind(this, 'From', 'openTicketSummaryReport'),
					},
					To: {
						value: '',
						open: false,
						onClick: this.toggleCalArr.bind(this, 'To', 'openTicketSummaryReport'),
					},
				},
			],
		}
		this.tenantId = this.props.profile && this.props.profile.tenantUid
	}
	resetField() {}
	downloadAll() {
		let { selected, allowed } = this.state
		let m = this.getReports()
		const {
			globalSetting: { uiFeature },
			identity: { roles },
			t,
		} = this.props
		let tickets = uiFeature && uiFeature.tickets

		if (tickets && tickets.report) {
			allowed = tickets && tickets.report && tickets.report.allowed
		}
		let mspTenant = uiFeature && uiFeature.admin && uiFeature.admin.Customer.status
		let customerAgent = roles && roles.length > 0 && roles.find(role => role === 'customer_agent')
		if (mspTenant && customerAgent) {
			allowed = allowed.filter(e => e === 'ticketReport')
		}
		m = m.filter(element => allowed.includes(element.name))
		m.map(el => {
			if (selected.includes(el.name)) {
				setTimeout(() => {
					el.action('downloadAll', el.name)
				}, 300)
			}
		})
	}
	async getTicketReport(downloadType, reportName) {
		this.setState({ loading: true })
		let statusFilterValue = null
		let queueFilterValue = null
		// let statusFilterValue=this.state.statusValue !=null && this.state.statusValue != 'undefined' ? this.state.statusValue.map(val => val.value) : null
		// let queueFilterValue=this.state.queueValue !=null && this.state.queueValue != 'undefined' ? this.state.queueValue.map(val => val.value) : null
		let date = this.getDateRange(downloadType, reportName)
		let continueDownlodad = reportName && reportName == 'openTicketSummaryReport' ? false : true
		//if(this.state.isChartVisible===true)
		if (reportName === 'openTicketSummaryReport') {
			statusFilterValue = this.state.statusValue != null && this.state.statusValue != 'undefined' ? this.state.statusValue.map(val => val.value) : null
			queueFilterValue = this.state.queueValue != null && this.state.queueValue != 'undefined' ? this.state.queueValue.map(val => val.value) : null
			const addOneDay = date => {
				date.setDate(date.getDate() + 1)
				let vals = moment(date).format('YYYY-MM-DD')
				return vals
			}
			let endDate = this.state.popupEndDate
			let end = new Date(endDate)
			let newEndDate = addOneDay(end)

			const reduceOneDay = date => {
				date.setDate(date.getDate() - 1)
				let vals = moment(date).format('YYYY-MM-DD')
				return vals
			}
			let stdDate = this.state.popupStartDate
			let std = new Date(stdDate)
			let newStdDate = reduceOneDay(std)

			date = { start: `${newStdDate}`, end: `${newEndDate}` }
			let filter = '$filter=('
			if (this.state.statusValue == null) {
				//statusFilterValue=`{${this.state.allData.Status.join(',')}}`
				statusFilterValue = this.state.allData.Status.map((vals, i) => `'${vals}'`)
				statusFilterValue = statusFilterValue.join(',')
				statusFilterValue = `',${statusFilterValue},'`
				for (let i = 0; i < this.state.allData.Status.length; i++) {
					filter += 'data_status_toState '
					if (i == this.state.allData.Status.length - 1) filter += `eq '${this.state.allData.Status[i]}') and (`
					else filter += `eq '${this.state.allData.Status[i]}' or `
				}
			}
			if (this.state.statusValue != null) {
				//filter=`$filter=data_status_toState eq '${this.state.statusFilterValue}' and (`
				for (let i = 0; i < statusFilterValue.length; i++) {
					filter += 'data_status_toState '
					if (i == statusFilterValue.length - 1) filter += `eq '${statusFilterValue[i]}') and (`
					else filter += `eq '${statusFilterValue[i]}' or `
				}
				//statusFilterValue=`{${statusFilterValue.join(',')}}`
				statusFilterValue = statusFilterValue.map((vals, i) => `'${vals}'`)
				statusFilterValue = statusFilterValue.join(',')
				statusFilterValue = `',${statusFilterValue},'`
			}
			if (this.state.queueValue == null) {
				//let vals=['a','b','c']
				queueFilterValue = this.state.allData.Queue.map((vals, i) => `'${vals}'`)
				//queueFilterValue=`{${this.state.allData.Queue.join(',')}}`
				queueFilterValue = queueFilterValue.join(',')
				queueFilterValue = `',${queueFilterValue},'`
				for (let i = 0; i < this.state.allData.Queue.length; i++) {
					filter += 'queue '
					if (i == this.state.allData.Queue.length - 1) filter += `eq '${this.state.allData.Queue[i]}')`
					else filter += `eq '${this.state.allData.Queue[i]}' or `
				}
			}
			if (this.state.queueValue != null) {
				//filter+=`queue eq '${this.state.statusFilterValue}')`

				for (let i = 0; i < queueFilterValue.length; i++) {
					filter += 'queue '
					if (i == queueFilterValue.length - 1) filter += `eq '${queueFilterValue[i]}')`
					else filter += `eq '${queueFilterValue[i]}' or `
				}
				//queueFilterValue=`{${queueFilterValue.join(',')}}`
				queueFilterValue = queueFilterValue.map((vals, i) => `'${vals}'`)
				queueFilterValue = queueFilterValue.join(',')
				queueFilterValue = `',${queueFilterValue},'`
			}
			let urlFilter = `${filter}`
			let top = this.state.allData && this.state.allData?.TotalTicketCount ? this.state.allData.TotalTicketCount : '1000'
			let url = localStorage.getItem('apiUrl')
			let apiUrlCustom = `${url}/ticketing/caseValue/myAllTickets?${urlFilter} and (createdAt ge '${date.start}' and createdAt le '${date.end}')&$top=${top}`
			const requestOptions = {
				method: 'GET',
				headers: { Pragma: 'no-cache', 'Content-Type': 'application/json', clientApp: `${window.location.pathname.split('/')[1]}` },
				url: `${apiUrlCustom}`,
			}
			let response = await identityServices.identityApi.request(requestOptions)
			countVal = response?.data.count
			const monthNames = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'August', 'Sept', 'Oct', 'Nov', 'Dec']
			const createdAtMonthNum = response?.data.rows.map(vals => vals.createdAt.split('-')[1])
			let filteredVals = []
			if (countVal > 1000 && reportName == 'openTicketSummaryReport') {
				this.setState({ isChartVisible: true })
				for (let i = 0; i < monthNames.length; i++) {
					let vals = createdAtMonthNum.filter(val => Number(val) == i + 1)
					let objectData = { name: `${monthNames[i]}`, total: `${vals.length}` }
					filteredVals.push(objectData)
				}
				this.setState({ displayModal: true, loading: false })
				this.setState({ chartData: filteredVals })
			} else if (countVal <= 1000 && reportName == 'openTicketSummaryReport') {
				continueDownlodad = true
			}
		}
		if (reportName != 'openTicketSummaryReport' || continueDownlodad == true) {
			if (reportName && reportName != 'openTicketSummaryReport') {
				queueFilterValue = this.state.allData?.Queue?.map((vals, i) => `'${vals}'`)
				queueFilterValue = queueFilterValue.join(',')
				queueFilterValue = `',${queueFilterValue},'`
			}
			this.setState({ isChartVisible: false })
			this.setState({ loading: true })
			let { t } = this.props
			let domain = localStorage && localStorage.getItem('product') ? localStorage?.getItem('product') : null

			// let allDomain=localStorage && localStorage.getItem('productSubcribed') ?localStorage?.getItem('productSubcribed') :null

			let filteredDomain = null
			if (domain && domain != 'undefined') {
				filteredDomain = domain
			}
			if (filteredDomain === null) filteredDomain = `{${localStorage.getItem('allDomains')}}`
			else if (filteredDomain != null) filteredDomain = `{${filteredDomain}}`
			//statusFilterValue=`','Assigned','Submitted','`
			let username = this.props.profile && this.props.profile.preferred_username ? this.props.profile.preferred_username : null
			let fileName = `${reportName}_${moment(date.start).format('MMM_DD-YYYY')}_to_${moment(date.end).format('MMM_DD-YYYY')}`
			this.props.getStdReport(
				this.props.profile && this.props.profile.tenantUid,
				reportName,
				date.start,
				date.end,
				username,
				fileName,
				date.notes,
				t,
				statusFilterValue,
				queueFilterValue,
				filteredDomain,
				'default'
			)
			this.setState({
				popUp: true,
			})
		}
	}

	getDateRange(downloadType, reportName) {
		let start,
			end,
			notes,
			{ reportsArr } = this.state
		if (downloadType == 'downloadIndividual') {
			reportsArr.forEach(elem => {
				if (elem.name == reportName) {
					start = elem.startDate
					end = elem.endDate
					notes = elem.notes
				}
			})
		} else if (downloadType == 'downloadAll') {
			reportsArr.forEach(elem => {
				if (elem.name == reportName) {
					start = this.state.filters.startDate
					end = this.state.filters.endDate
					notes = elem.notes
				}
			})
		} else {
			start = this.state.filters.startDate
			end = this.state.filters.endDate
			notes = 'ticketReport'
		}
		return {
			start,
			end,
			notes,
		}
	}
	isAllSelected() {
		let report = this.getReports().map(el => el.name)
		delete report[0]
		let { selected, allowed } = this.state
		let isAllSelected = true
		report = report.filter(element => allowed.includes(element))
		report.map(el => {
			if (!selected.includes(el)) {
				isAllSelected = false
			}
		})
		return isAllSelected
	}

	isSelected(name) {
		if (name == 'All Reports') {
			return this.isAllSelected()
		}

		let { selected } = this.state
		return selected.includes(name)
	}
	noteSelect(name) {
		if (name === 'ticketReport') return false
		else return true
	}
	handleSelect(event) {
		let name = event.target.value
		let selected = this.state.selected

		if (!selected.includes(name)) {
			selected.push(name)
		} else {
			selected = selected.filter(el => el != name)
		}

		this.setState({
			selected,
		})
	}
	getReports() {
		let { reportsArr } = this.state
		return reportsArr
	}
	dateTimeChange(type, event) {
		let filters = this.state.filters
		event = event.format('YYYY-MM-DD')
		let selectFrom, selectTo
		if (type == 'From') {
			selectFrom = false
			selectTo = true
			filters.startDate = event
			filters.endDate = ''
		} else {
			selectFrom = false
			selectTo = false
			filters.endDate = event
		}
		this.setState({
			selectFrom,
			selectTo,
			filters,
		})
	}
	dateTimeChangeArrFrom(type, reportName, event) {
		let { reportsArr } = this.state

		event = event.format('YYYY-MM-DD')
		if (type == 'From') {
			reportsArr.map((elem, i) => {
				if (elem.name == reportName) {
					elem.startDate = event
					elem.endDate = ''
					elem.From.open = false
					elem.To.open = true
				}
			})
		}

		this.setState({
			reportsArr,
		})
	}
	handleNoteChange(type, reportName, event) {
		let { reportsArr } = this.state

		let value = event.target.value
		let setNote = 'ticketReport'
		if (value === 'ticketReport') {
			setNote = 'ticketReportAll'
			let dateValue = reportsArr.find(val => val.name == reportName) || null 
			if(dateValue){
				let startDateValue = moment(dateValue?.startDate,"YYYY-MM-DD")
				let endDateValue = moment(dateValue?.endDate, "YYYY-MM-DD")
				let indexValue = reportsArr.findIndex(val => val.name == reportName) 
				let diff = moment.duration(endDateValue.diff(startDateValue)).asDays()
				if(diff > 6){
					let addedDays = moment(startDateValue, "YYYY-MM-DD").add(6, 'days')
					reportsArr[indexValue].endDate = addedDays
				}
				}
		} else if (value === 'approvalReport') {
			setNote = 'approvalReportAll'
		} else if (value === 'slaReport') {
			setNote = 'slaReportAll'
		} else {
			setNote = 'ticketReport'
		}
		if (type == 'notes') {
			reportsArr.map((elem, i) => {
				if (elem.name == reportName) {
					elem.notes = setNote
				}
			})
		}

		this.setState({
			reportsArr,
		})
	}
	handleChange(e) {
		if (e.target.name == 'Status') this.setState({ statusFilterValue: e.target.value })
		else if (e.target.name == 'Queue') this.setState({ queueFilterValue: e.target.value })
	}
	handleStatusChanges(e) {
		let lastValue = e.length
		if (lastValue > 0) {
			if (this.state.allData?.Status.includes(e[lastValue - 1].value)) {
				this.setState({ statusValue: e })
			}
		} else {
			this.setState({ statusValue: null })
		}
	}
	handleQueueChanges(e) {
		let lastValue = e.length
		if (lastValue > 0) {
			if (this.state.allData?.Queue.includes(e[lastValue - 1].value)) {
				this.setState({ queueValue: e })
			}
		} else {
			this.setState({ queueValue: null })
		}
	}

	dateTimeChangeArrTo(type, reportName, event) {
		let { reportsArr } = this.state

		event = event.format('YYYY-MM-DD')
		if (type == 'To') {
			reportsArr.map((elem, i) => {
				if (elem.name == reportName) {
					elem.endDate = event
					elem.From.open = false
					elem.To.open = false
				}
			})
		}

		this.setState({
			reportsArr,
		})
	}
	toggleCal(type) {
		if (type == 'from') {
			this.setState({
				selectFrom: !this.state.selectFrom,
				selectTo: false,
			})
		} else {
			this.setState({
				selectFrom: false,
				selectTo: !this.state.selectTo,
			})
		}
	}
	toggleCalArr(type, reportName) {
		let { reportsArr } = this.state,
			reportFind
		if (type == 'From') {
			reportsArr.map((elem, i) => {
				if (elem.name == reportName) {
					elem.From.open = !elem.From.open
					elem.To.open = false
				} else {
					elem.From.open = false
					elem.To.open = false
				}
			})
		} else {
			reportsArr.map((elem, i) => {
				if (elem.name == reportName) {
					elem.From.open = false
					elem.To.open = !elem.To.open
				} else {
					elem.From.open = false
					elem.To.open = false
				}
			})
		}

		this.setState({
			reportsArr,
		})
	}
	componentWillReceiveProps(props) {
		const { loading, itemData } = props && props.reports
		this.setState({ loading: loading, reportData: itemData })
	}

	async componentDidMount() {
		const notIncludesArray = ['Approved', 'Rejected', 'Closed', 'Resolved', 'Deleted', 'Draft']
		let product = localStorage && localStorage.getItem('product') ? localStorage?.getItem('product') : null
		let headers = {}
		if (product != null) {
			headers = { 'Content-Type': 'application/json', usecase: `${product}`, clientapp: 'tickets' }
		} else {
			headers = { 'Content-Type': 'application/json', removeusecase: true, clientapp: 'tickets' }
		}
		this.setStartDateValue()
		let url = localStorage.getItem('apiUrl')
		let allData = {}
		let apiUrlCustom = `${url}/ticketing/queue/findAndCountAll?$filter=status ne 'Deleted' and status ne 'Draft'&$skip=0&$top=50`
		const requestOptions = {
			method: 'GET',
			headers: headers,
			url: `${apiUrlCustom}`,
		}
		let response = await identityServices.identityApi.request(requestOptions)
		if (response && response.status && response.status === 200) {
			if (response && response.data && response.data.rows) {
				response.data = response.data.rows
			}
			// const {
			// 	globalSetting: { uiFeature },
			// 	identity: { roles },
			// 	t,
			// } = this.props
			let mspTenant = this.props?.globalSetting?.uiFeature?.admin?.Customer?.status
			let customerAgent = this.props?.identity?.roles && this.props?.identity?.roles.length > 0 && this.props?.identity?.roles.find(role => role === 'customer_agent')
			let userName = this.props.profile && this.props.profile.preferred_username
			let datas
			if (mspTenant && customerAgent) {
				let customerAgentQueue = response.data.filter(e => e.properties?.customerAgents.includes(userName))
				datas = customerAgentQueue.map(data => ({ label: data.queueName, value: data.queueName }))
			} else {
				let responseData = response.data.filter(data => data.groupApprovers.includes(userName))
				datas = responseData.map(data => ({ label: data.queueName, value: data.queueName }))
			}

			datas = datas.filter((obj, index) => {
				return index === datas.findIndex(o => obj.label === o.label && obj.value === o.value)
			})
			//   datas = datas.filter((element, index) => {
			// 		return datas.indexOf(element) === index;
			//  })

			//datas=datas.filter(obj=> )
			queueOptions = datas
			allData.Queue = datas.map(data => data.value)
			//datas.push(vals)
			// 						let queuesList = datas.length > 0
			// 	&& datas.map((item, i) => {
			//   return (
			//     <option key={i} value={item.value}>{item.label}</option>
			//   )
			// }, this);
			// 						this.setState({queueList:queuesList},)
		}
		apiUrlCustom = `${url}/ticketing/CaseValue/getTicketStatus`
		requestOptions.url = apiUrlCustom
		response = await identityServices.identityApi.request(requestOptions)

		if (response && response.status && response.status === 200) {
			// let vals={label: 'All', value: ' '}
			let datas = response.data.map(val => ({ label: val.name, value: val.name }))
			datas = datas.filter((obj, index) => {
				return index === datas.findIndex(o => obj.label === o.label && obj.value === o.value) && !notIncludesArray.includes(obj.label) && !notIncludesArray.includes(obj.value)
			})
			allData.Status = datas.map(data => data.value)
			statusOptions = datas
			// 						datas.push(vals)
			// 						let statusLists = datas.length > 0
			// 	&& datas.map((item, i) => {
			//   return (
			//     <option key={i} value={item.value}>{item.label}</option>
			//   )
			// }, this);
			// 						this.setState({statusList:statusLists},)
		}
		apiUrlCustom = `${url}/ticketing/CaseValue/myAllTickets/count?$filter=data_status_toState ne 'Closed' and data_status_toState ne 'Resolved' and data_status_toState ne 'Deleted' and data_status_toState ne 'Draft'`
		requestOptions.url = apiUrlCustom
		response = await identityServices.identityApi.request(requestOptions)
		if (response && response.status && response.status === 200) {
			allData.TotalTicketCount = response.data
		}
		this.setState({ allData: allData })
		let allowed = [
			'approvalReport',
			'feedbackReport',
			'slaReport',
			'ticketReport',
			'queueSummaryReport',
			'sourceSummaryReport',
			'agentWorkloadReport',
			'botTicketReport',
			'categoryWiseReport',
			'openTicketSummaryReport',
		]
		const {
			globalSetting: { uiFeature },
			t,
		} = this.props
		let tickets = uiFeature && uiFeature.tickets

		if (tickets && tickets.report) {
			allowed = tickets && tickets.report && tickets.report.allowed
		}
		if (window.location.href.includes('approvals')) {
			allowed = tickets && tickets.report && tickets.report.approvalReport
		}
		let mspTenant = this.props?.globalSetting?.uiFeature?.admin?.Customer?.status
		let customerAgent = this.props?.identity?.roles && this.props?.identity?.roles.length > 0 && this.props?.identity?.roles.find(role => role === 'customer_agent')
		if (mspTenant && customerAgent) {
			allowed = allowed.filter(e => e === 'ticketReport')
		}
		this.setState({
			allowed: allowed,
		})
	}

	componentWillUnmount() {
		this.setState({
			popUp: false,
		})
	}

	downloadIndividual(report) {
		report.action('downloadIndividual', report.name)
		setTimeout(() => {
			this.resetField(report)
		}, 300)
	}
	handleSelectAll() {
		let report = this.getReports().map(el => el.name)
		if (this.state.selected.length < report.length) {
			this.setState({
				selected: report,
			})
		} else {
			this.setState({
				selected: [],
			})
		}
	}
	validReportDate = (type, reportName, note, current) => {
		let diff = 31
		if (note && note === 'ticketReportAll') diff = 7
		else if (reportName === 'openTicketSummaryReport') diff = 365
		else diff = 31
		let today = moment(),
			{ reportsArr } = this.state,
			startDate
		let currentYear = moment().diff(moment().startOf('year'), 'day') > 60 ? moment().startOf('year') : moment().subtract(60, 'day').startOf('month')
		let stDate
		reportsArr.forEach(elem => {
			if (elem.name == reportName) {
				startDate = elem.startDate
				stDate = elem.startDate
			}
		})
		let createdAt = moment(currentYear).subtract(1, 'day')
		if (type == 'From') return current.isBefore(today)
		if (type == 'To')
			return current.isAfter(moment(startDate).subtract(1, 'day').format('YYYY-MM-DD')) && current.isBefore(moment(stDate).add(diff, 'day')) && current.isBefore(today)

		return current.isAfter(moment(startDate).subtract(1, 'day').format('YYYY-MM-DD')) && current.isBefore(today)
	}

	render() {
		const { loading, reportData, popUp } = this.state
		const tbody = this.getReports()
		let date = {
			From: {
				value: this.state.filters.startDate,
				open: this.state.selectFrom,
				onClick: this.toggleCal.bind(this, 'from'),
			},
			To: {
				value: this.state.filters.endDate,
				open: this.state.selectTo,
				onClick: this.toggleCal.bind(this, 'to'),
			},
		}

		let valid = (type, current) => {
			let diff = 31
			let today = moment()
			if (type == 'From') return current.isBefore(today)
			if (type == 'To')
				return (
					current.isAfter(moment(this.state.filters.startDate).subtract(1, 'day').format('YYYY-MM-DD')) &&
					current.isBefore(moment(this.state.filters.startDate).add(diff, 'day')) &&
					current.isBefore(today)
				)
			return current.isAfter(moment(this.state.filters.startDate).subtract(1, 'day').format('YYYY-MM-DD')) && current.isBefore(today)
		}

		let allowed = [
			'approvalReport',
			'feedbackReport',
			'slaReport',
			'ticketReport',
			'queueSummaryReport',
			'sourceSummaryReport',
			'agentWorkloadReport',
			'botTicketReport',
			'categoryWiseReport',
			'openTicketSummaryReport',
		]
		const {
			globalSetting: { uiFeature },
			identity: { roles },
			t,
		} = this.props
		let tickets = uiFeature && uiFeature.tickets
		if (tickets && tickets.report) {
			allowed = tickets && tickets.report && tickets.report.allowed
		}
		if (window.location.href.includes('approvals')) {
			allowed = tickets && tickets.report && tickets.report.approvalReport
		}
		if (!allowed || allowed.length < 1) {
			return null
		}

		let mspTenant = uiFeature && uiFeature.admin && uiFeature.admin.Customer.status
		let customerAgent = roles && roles.length > 0 && roles.find(role => role === 'customer_agent')
		if (mspTenant && customerAgent) {
			allowed = allowed.filter(e => e === 'ticketReport')
		}
		return (
			<div className="reportSection">
				{loading && <Loader />}
				<div className="common-heading row">
					<div className="row table-title">
						<div className="col-sm-12">
							<div className="heading">
								<h5>{t('Reporting/Analytics')}</h5>
							</div>
						</div>
					</div>
				</div>
				<section>
					<div className="row" style={{alignItems:'center'}}>
					<div className='col-sm-6'>
					{this.state.selected.length > 0 && (
						<div style={{alignItems:'center'}}>
							<Button type="danger" className="btn btn-danger" onClick={this.downloadAll.bind(this)}>
								{t('Download')} {this.isAllSelected() ? t('All') : t('Selected')}
							</Button>
						</div>
					)}
					</div>
						<div className="filters col-sm-6 pull-right">
							{Object.keys(date).map((key, i) => (
								<FormGroup className="custom-margin-form-group" key={i}>
									<Label for="ex-url">{t(key)}</Label>
									<div className="custom-calendar">
										<span className="set-date-sec" name="schedule_date" onClick={this.state.selected.length && date[key].onClick ? date[key].onClick : null}>
											{date[key].value ? moment(date[key].value, 'YYYY-MM-DD').format('DD MMM YY') : t('Select')}
											<span className="cal-ico">
												<i className="fa fa-calendar fa-lg" />
											</span>
										</span>
										<div className={`custom-calendar-inner ${key == 'From' ? 'cal-left-zero' : 'cal-right-zero'}`} style={{ display: date[key].open ? 'block' : 'none' }}>
											<Datetime
												isValidDate={valid.bind(this, key)}
												value={key == 'To' ? (date[key].value && date[key].value != '' ? new Date(date[key].value) : new Date(date['From'].value)) : date[key].value}
												input={false}
												onChange={this.dateTimeChange.bind(this, key)}
												viewDate={date[key].value}
												timeFormat={false}
											/>
										</div>
									</div>
								</FormGroup>
							))}
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<div className="table-responsive">
								<Table className="table">
									<colgroup>
										<col width="5%" />
										<col width="20%" />
										<col width="30%" />
										<col width="30%" />
										<col width="15%" />
									</colgroup>
									<thead>
										<tr>
											<th>
												<span>
													<Input type="checkbox" id="inline-checkbox0" name="checkbox[]" checked={this.isAllSelected()} onChange={this.handleSelectAll.bind(this)} />
												</span>
											</th>
											<th>{t('Report Name')}</th>
											<th>{t('Description')}</th>
											<th>{t('Condition')}</th>
											<th>{t('Date Range')}</th>
											<th>{t('Action')}</th>
										</tr>
									</thead>
									<tbody>
										{tbody.map(
											(el, i) =>
												allowed.includes(el.name) && (
													<tr key={el.name + i}>
														<td>
															<div className="reports-top-20">
																<Input
																	type="checkbox"
																	id={`inline-checkbox${i + 1}`}
																	name="checkbox[]"
																	className="checkbox_margin"
																	value={el.name}
																	checked={this.isSelected(el.name)}
																	onChange={el.inputAction ? el.inputAction : this.handleSelect.bind(this)}
																/>
															</div>
														</td>
														<td>
															{' '}
															
																{el?.label=== "Open Ticket Summary" ?
															<Tooltip hasArrow label='The data is available for last one year.' bg='blue.300' color='white'>
																	<div  className="reports-top-20">{t(el.label)}</div>
															</Tooltip> : <div  className="reports-top-20">{t(el.label)}</div> }
														</td>
														<td>
															<div className="reports-top-20">{t(el.description)}</div>
														</td>
														<td>
															{el.notes && (
																<div className="reports-top-20">
																	<Input
																		id={`inline-checkboxnote${i + 1}`}
																		className="checkbox_margin"
																		name="notes"
																		value={el.notes}
																		onChange={this.handleNoteChange.bind(this, 'notes', el.name)}
																		type="checkbox"
																	/>{' '}
																	{t('All Notes')}
																</div>
															)}
														</td>
														<td>
															{el.name == 'openTicketSummaryReport' && (
																<>
																	<div style={{ display: 'flex', justifyContent: 'space-between' }}>
																		<div style={{ alignItems: 'center', justifyContent: 'space-around' }}>
																			<label>
																				<span style={{ fontWeight: 'bold' }}>Status: </span>
																			</label>
																			<div className="dropdown-container" style={{ width: '160px' }}>
																				<Select
																					menuPlacement="top"
																					name="Status"
																					options={statusOptions}
																					placeholder="Select status"
																					value={this.state.statusValue}
																					onChange={this.handleStatusChanges.bind(this)}
																					isMulti
																				/>
																			</div>
																		</div>
																		<div style={{ alignItems: 'center', justifyContent: 'space-around' }}>
																			<label>
																				<span style={{ fontWeight: 'bold' }}>Queue: </span>
																			</label>
																			<div className="dropdown-container" style={{ width: '160px' }}>
																				<Select
																					menuPlacement="top"
																					name="Queue"
																					options={queueOptions}
																					placeholder="Select queue"
																					value={this.state.queueValue}
																					onChange={this.handleQueueChanges.bind(this)}
																					isMulti
																				/>
																			</div>
																		</div>
																	</div>
																</>
															)}
															{el.name != 'openTicketSummaryReport' && (
																<div className="filters">
																	<FormGroup className="custom-margin-form-group" key={`From_${i}`}>
																		<Label for="ex-url">{t('From')}</Label>
																		<div className="custom-calendar">
																			<span className="set-date-sec" name="schedule_date" onClick={!this.state.selected.length && el.From.onClick ? el.From.onClick : null}>
																				{el.startDate ? moment(el.startDate, 'YYYY-MM-DD').format('DD MMM YY') : t('Select')}
																				<span className="cal-ico">
																					<i className="fa fa-calendar fa-lg" />
																				</span>
																			</span>
																			<div className="custom-calendar-inner cal-left-zero" style={{ display: el.From.open ? 'block' : 'none' }}>
																				<Datetime
																					key={`From_Date_${i}`}
																					isValidDate={this.validReportDate.bind(this, 'From', el.name, el.notes)}
																					defaultValue={el.From.value}
																					input={false}
																					onChange={this.dateTimeChangeArrFrom.bind(this, 'From', el.name)}
																					viewDate={el.startDate}
																					timeFormat={false}
																				/>
																			</div>
																		</div>
																	</FormGroup>

																	<FormGroup className="custom-margin-form-group" key={`To_${i}`}>
																		<Label for="ex-url">{t('To')}</Label>
																		<div className="custom-calendar">
																			<span className="set-date-sec" name="schedule_date" onClick={!this.state.selected.length && el.To.onClick ? el.To.onClick : null}>
																				{el.endDate ? moment(el.endDate, 'YYYY-MM-DD').format('DD MMM YY') : t('Select')}
																				<span className="cal-ico">
																					<i className="fa fa-calendar fa-lg" />
																				</span>
																			</span>
																			<div className="custom-calendar-inner cal-left-zero" style={{ display: el.To.open ? 'block' : 'none' }}>
																				<Datetime
																					key={`To_Date_${i}`}
																					isValidDate={this.validReportDate.bind(this, 'To', el.name, el.notes)}
																					value={el.endDate && el.endDate != '' ? new Date(el.endDate) : new Date(el.startDate)}
																					ref="toDate"
																					input={false}
																					onChange={this.dateTimeChangeArrTo.bind(this, 'To', el.name)}
																					timeFormat={false}
																				/>
																			</div>
																		</div>
																	</FormGroup>
																</div>
															)}
														</td>
														<td>
															{el.action && (
																<Button
																	type="danger"
																	className="btn btn-danger reports-top-20"
																	disabled={!this.state.selected.length > 0 ? false : true}
																	onClick={this.downloadIndividual.bind(this, el)}>
																	{t('Download')}
																</Button>
															)}
														</td>
													</tr>
												)
										)}
									</tbody>
								</Table>
							</div>
						</div>
					</div>
				</section>
				{/* {this.state.chartData && this.state.chartData.length >0  && <ModalPopup display={true} chartData={this.state.chartData} queueList={this.state.queueList}/>} */}
				{this.state.chartData && this.state.chartData.length > 0 && this.modalPopup(this.state.displayModal, this.state.chartData, this.state.queueList)}
				{reportData && reportData.requestId && popUp && <AsyncJobsModal {...this.props} modal={true} jobData={reportData} />}
			</div>
		)
	}
}

export default withTranslation()(FilterReview)
